document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-menu]');
  const drawer = document.querySelector('#MobileMenu');
  if (menuButton && drawer) {
    menuButton.addEventListener('click', () => {
      const isOpen = !drawer.hasAttribute('hidden');
      if (isOpen) drawer.setAttribute('hidden', ''); else drawer.removeAttribute('hidden');
      menuButton.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  document.querySelectorAll('[data-cart-quantity-minus], [data-cart-quantity-plus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      const subtract = button.hasAttribute('data-cart-quantity-minus');
      input.value = Math.max(subtract ? current - 1 : current + 1, 0);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-quantity-minus], [data-product-quantity-plus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      const subtract = button.hasAttribute('data-product-quantity-minus');
      input.value = Math.max(subtract ? current - 1 : current + 1, 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const setProductMedia = (source, mediaId = '') => {
    const mainImage = document.querySelector('.product-main-media img');
    if (mainImage && source) {
      mainImage.src = source;
      mainImage.srcset = source;
    }
    document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const isActive = Boolean(mediaId) && thumb.dataset.mediaId === mediaId;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
    });
  };

  document.querySelectorAll('[data-gallery-thumb]').forEach(button => {
    button.addEventListener('click', () => setProductMedia(button.dataset.src, button.dataset.mediaId));
  });

  document.querySelectorAll('[data-variant-selector]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const matchingThumbnail = option.dataset.mediaId
        ? document.querySelector(`[data-gallery-thumb][data-media-id="${option.dataset.mediaId}"]`)
        : null;
      setProductMedia(matchingThumbnail?.dataset.src || option.dataset.imageSrc, option.dataset.mediaId);
    });
  });

  document.querySelectorAll('[data-dormeria-accordions]').forEach(group => {
    group.querySelectorAll('details').forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        group.querySelectorAll('details').forEach(other => {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  document.querySelectorAll('[data-measure-form]').forEach(form => {
    const result = form.querySelector('[data-measure-result]');
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const fields = new FormData(form);
      const selector = form.closest('[data-product]')?.querySelector('[data-variant-selector]');
      const selectedVariant = selector?.options[selector.selectedIndex]?.textContent.trim() || 'No indicada';
      const name = fields.get('name').trim();
      const phone = fields.get('phone').trim();
      const city = fields.get('city').trim() || 'No indicada';
      const measure = fields.get('measure').trim();
      const note = fields.get('note').trim() || 'Sin notas adicionales';
      const message = [
        'Hola DORMERIA, necesito ayuda para elegir una medida.',
        '',
        `Producto: ${form.dataset.productTitle || 'No indicado'}`,
        `Opción: ${selectedVariant}`,
        `Nombre: ${name}`,
        `Teléfono: ${phone}`,
        `Ciudad: ${city}`,
        `Medida solicitada: ${measure}`,
        `Consulta: ${note}`,
        '',
        'He rellenado esta solicitud desde la ficha de producto y agradezco que me contactéis antes de confirmar el pedido.'
      ].join('\n');
      const whatsappUrl = `https://wa.me/34624588165?text=${encodeURIComponent(message)}`;
      if (result) {
        result.hidden = false;
        result.textContent = 'Abrimos WhatsApp con tu consulta preparada. Revísala y pulsa Enviar para hablar directamente con DORMERIA.';
      }
      const whatsappWindow = window.open(whatsappUrl, '_blank', 'noopener');
      if (!whatsappWindow) window.location.assign(whatsappUrl);
    });
  });

  const codReturnCta = document.querySelector('[data-cod-return-cta]');
  if (codReturnCta) {
    const getCodForm = () => document.querySelector('#leadform-embedded-container .leadform-container, #leadform-submit-form');
    let animationFrame;
    const updateCodReturnCta = () => {
      const codForm = getCodForm();
      document.documentElement.classList.toggle('has-webi-leadform', Boolean(codForm));
      const formHasPassedCompletely = codForm && codForm.getBoundingClientRect().bottom < 0;
      codReturnCta.hidden = !formHasPassedCompletely;
    };
    const queueCodReturnCtaUpdate = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateCodReturnCta);
    };
    codReturnCta.addEventListener('click', () => {
      const codForm = getCodForm();
      if (!codForm) return;
      codForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => codForm.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true }), 550);
    });
    window.addEventListener('scroll', queueCodReturnCtaUpdate, { passive: true });
    window.addEventListener('resize', queueCodReturnCtaUpdate);
    new MutationObserver(queueCodReturnCtaUpdate).observe(document.body, { childList: true, subtree: true });
    queueCodReturnCtaUpdate();
  }

  document.querySelectorAll('[data-sort-by]').forEach(select => {
    select.addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  });

  const policyTarget = window.location.hash ? document.querySelector(window.location.hash) : null;
  if (policyTarget && policyTarget.matches('details')) {
    policyTarget.open = true;
    window.setTimeout(() => policyTarget.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
  }

  const italianOriginNotice = document.querySelector('[data-italian-origin-notice]');
  if (italianOriginNotice) {
    const readNumber = (name, fallback) => {
      const value = Number(italianOriginNotice.dataset[name]);
      return Number.isFinite(value) && value > 0 ? value : fallback;
    };
    const noticeConfig = {
      delayMs: readNumber('delaySeconds', 5) * 1000,
      visibleMs: readNumber('visibleSeconds', 4) * 1000,
      cooldownMs: readNumber('cooldownSeconds', 90) * 1000,
      maxPerSession: readNumber('maxPerSession', 2),
      mobileClearance: readNumber('mobileClearance', 84)
    };
    const storagePrefix = 'dormeria-italian-origin-notice';
    const storage = {
      get: key => { try { return window.sessionStorage.getItem(`${storagePrefix}:${key}`); } catch (_) { return null; } },
      set: (key, value) => { try { window.sessionStorage.setItem(`${storagePrefix}:${key}`, String(value)); } catch (_) {} }
    };
    const getSessionCount = () => Number(storage.get('count') || 0);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const closeButton = italianOriginNotice.querySelector('[data-italian-notice-close]');
    let showTimer;
    let hideTimer;
    let lastFormActivity = 0;

    const isCheckout = () => document.body.classList.contains('template-checkout') || /\/checkout(?:\/|$)/.test(window.location.pathname);
    const isFormControl = element => element?.matches('input, select, textarea, [contenteditable="true"], iframe');
    const recentFormActivity = () => isFormControl(document.activeElement) || Date.now() - lastFormActivity < 8000;
    const isVisible = element => {
      if (!element || element.hidden || getComputedStyle(element).display === 'none') return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    };
    const hasBlockingOverlay = () => [...document.querySelectorAll('#shopify-pc__banner, [data-shopify-pc-banner]')].some(isVisible);
    const canShowNotice = () => {
      const lastShown = Number(storage.get('last-shown') || 0);
      return !isCheckout()
        && !storage.get('closed')
        && getSessionCount() < noticeConfig.maxPerSession
        && (!lastShown || Date.now() - lastShown >= noticeConfig.cooldownMs);
    };
    const hideNotice = () => {
      window.clearTimeout(hideTimer);
      italianOriginNotice.classList.remove('is-visible');
      window.setTimeout(() => { italianOriginNotice.hidden = true; }, reducedMotion.matches ? 0 : 460);
    };
    const showNotice = () => {
      if (!canShowNotice()) return false;
      italianOriginNotice.hidden = false;
      window.requestAnimationFrame(() => italianOriginNotice.classList.add('is-visible'));
      storage.set('count', getSessionCount() + 1);
      storage.set('last-shown', Date.now());
      hideTimer = window.setTimeout(hideNotice, noticeConfig.visibleMs);
      return true;
    };
    const attemptShow = () => {
      if (!canShowNotice()) return;
      if (recentFormActivity() || hasBlockingOverlay() || document.visibilityState !== 'visible') {
        showTimer = window.setTimeout(attemptShow, 1200);
        return;
      }
      showNotice();
    };
    const scheduleNotice = () => {
      if (!canShowNotice()) return;
      window.clearTimeout(showTimer);
      showTimer = window.setTimeout(attemptShow, noticeConfig.delayMs);
    };
    const updateMobileClearance = () => {
      if (!window.matchMedia('(max-width: 620px)').matches) {
        italianOriginNotice.style.removeProperty('--italian-origin-bottom');
        return;
      }
      const floatingCtas = [...document.querySelectorAll('[data-cod-return-cta], .cod-return-cta')].filter(element => {
        const rect = element.getBoundingClientRect();
        return !element.hidden && getComputedStyle(element).display !== 'none' && rect.height > 0 && rect.bottom >= window.innerHeight - 4;
      });
      const ctaHeight = floatingCtas.reduce((height, element) => Math.max(height, element.getBoundingClientRect().height), 0);
      italianOriginNotice.style.setProperty('--italian-origin-bottom', `${Math.max(noticeConfig.mobileClearance, ctaHeight + 22)}px`);
    };

    document.addEventListener('focusin', event => { if (isFormControl(event.target)) lastFormActivity = Date.now(); });
    document.addEventListener('input', event => { if (isFormControl(event.target)) lastFormActivity = Date.now(); }, true);
    document.addEventListener('change', event => { if (isFormControl(event.target)) lastFormActivity = Date.now(); }, true);
    document.addEventListener('click', event => { if (event.target.matches('iframe')) lastFormActivity = Date.now(); }, true);
    closeButton?.addEventListener('click', () => {
      storage.set('closed', 'true');
      hideNotice();
    });
    window.addEventListener('resize', updateMobileClearance);
    new MutationObserver(updateMobileClearance).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    updateMobileClearance();
    scheduleNotice();
  }
});
